import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminOrderRentalPurchase.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminOrderRentalPurchase' */ './component')],
	render: ([AdminOrderRentalPurchase]) => <AdminOrderRentalPurchase />,
};

export default routes;
